<template>
    <div class="payment" :class="{show: show}">
        <div class="back_btn" @click='back'></div>
        <div class="close_btn" @click='close'></div>
        <!-- <vue-scroll style=""> -->
            <div ref='scroll' class="scroll_container">
                <div class="pay_box" v-show='payShow'>
                    <!-- 个人用户的表格 -->
                    <table v-if="$store.state.Order.submitData && $store.state.Order.submitData.accountType == '个人'" class="pay_table" border="0" cellspacing='0' cellpadding='0'>
                        <colgroup>
                            <col width='10%'/>
                            <col width='10%'/>
                            <col width='15%'/>
                            <col width='15%'/>
                            <col width='15%'/>
                            <col/>
                            <col/>
                            <col/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="8">订单信息</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="3">用户类型：<div class="content">个人</div>
                                </td>
                                <td colspan="2">真实姓名：<div class="content">{{payData && payData.userName}}</div>
                                </td>
                                <td colspan="3">{{payData && payData.idcard == "" ? '护照号' : '身份证号'}}：<div class="content">{{payData && (payData.idcard == '' ? payData.contactPassport : payData.idcard)}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">手机号码：<div class="content">{{payData && payData.phone}}</div>
                                </td>
                                <td colspan="5">发票类型：<div class="content">{{payData && payData.invoiceType == 0 ? '增值税普通发票（电子发票）' : '增值税专用发票'}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8">购买商品：<div class="content">{{payData && (payData.productName + ($store.state.Order.submitData.productId == '80' ? '+上海期货交易所一档+大连商品交易所一档+郑州商品交易所一档' : ''))}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" >数量：<div class="content" style="width:auto;">{{payData && payData.amount}}</div>
                                </td>
                                <td colspan="6">金额总计：<div class="content" style="margin-top:-4px;" v-html="payData && payData.total"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- 机构用户的表格 -->
                    <table v-if="$store.state.Order.submitData && $store.state.Order.submitData.accountType == '公司'" class="pay_table" border="0" cellspacing='0' cellpadding='0'>
                        <thead>
                            <tr>
                                <th colspan="9">订单信息</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="3">用户类型：<div class="content">机构</div>
                                </td>
                                <td colspan="3">机构名称：<div class="content">{{payData && payData.userName}}</div>
                                </td>
                                <td colspan="3">联系人姓名：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.contactname || '')}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">身份证号：<div class="content">{{payData && (payData.idcard || '')}}</div>
                                </td>
                                <td colspan="3">手机号码：<div class="content">{{payData && payData.phone}}</div>
                                </td>
                                <td colspan="3">发票类型：<div class="content">{{payData && payData.invoiceType == 0 ? '增值税普通发票（电子发票）' : '增值税专用发票'}}</div>
                                </td>
                            </tr>
                            
                            <tr v-if="$store.state.Order.submitData && $store.state.Order.submitData.invoicetype == 0">
                                <td colspan="3">发票名头：<div class="content">{{payData && payData.userName}}</div>
                                </td>
                                <td colspan="6">公司税号：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.faxNumber || '')}}</div>
                                </td>
                            </tr>
                            <template  v-if="$store.state.Order.submitData && $store.state.Order.submitData.invoicetype == 1">
                                <tr>
                                    <td colspan="3">发票名头：<div class="content">{{payData && payData.userName}}</div>
                                    </td>
                                    <td colspan="3">公司税号：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.faxNumber || '')}}</div>
                                    </td>
                                    <td colspan="3">开票地址：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.CompanyAddress || '')}}</div>
                                    </td>
                                </tr>

                                
                                <tr>
                                    <td colspan="3">开票电话：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.CompanyTelnumber || '')}}</div>
                                    </td>
                                    <td colspan="3">开票开户行：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.CompanyBank || '')}}</div>
                                    </td>
                                    <td colspan="3">开票账号：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.CompanyAccount || '')}}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="9">邮寄地址：<div class="content">{{$store.state.Order.submitData && ($store.state.Order.submitData.InvoiceAddr || '')}}</div>
                                    </td>
                                </tr>
                            </template>
                            <tr>
                                <td colspan="2" >数量：<div class="content" style="width:auto;">{{payData && payData.amount}}</div>
                                </td>
                                <td colspan="7">金额总计：<div class="content" style="margin-top:-4px;" v-html="payData && payData.total"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 class="title">请选择下方付款方式：</h3>

                    <div class="pay_item" 
                        v-show='((!isPaper && $store.state.Order.submitData && $store.state.Order.submitData.invoicetype == 0) || item.payGateId == "9999") && (item.payGateID != "9998" || $store.state.otherOrderId == "")' 
                        v-for="(item,index) in payTypes" 
                        :key="index" 
                        :style="{
                            background: 'url('+item.imgUrl+') '+(item.payName == '网上银行' ? '15px':'20px')+' center no-repeat white',
                            paddingLeft: item.payName == '支付宝扫码' ? '50px':'60px'
                        }" 
                        :class="{
                            active: selectIndex == index
                        }" 
                        @click='selectPayType(item, index)'
                    >{{item.payName}}</div>
                    
                    <div class="pay_item yzf" v-if="!isPaper && $route.query.prepay" :class="{active: selectIndex == payTypes.length}" @click='selectIndex = payTypes.length'>预付款扣除</div>
                    
                    
                    <!-- <div class="pay_item zfb" v-show='!isPaper && $store.state.Order.submitData && $store.state.Order.submitData.invoicetype == 0' :class="{active: selectIndex == 1}" @click='selectIndex = 1'>支付宝扫码</div>
                    <div class="pay_item wx" v-show='!isPaper && $store.state.Order.submitData && $store.state.Order.submitData.invoicetype == 0' :class="{active: selectIndex == 0}" @click='selectIndex = 0'>微信扫码</div>
                    <div class="pay_item yl" v-show='!isPaper && $store.state.Order.submitData && $store.state.Order.submitData.invoicetype == 0' :class="{active: selectIndex == 2}" @click='selectIndex = 2'>网上银行</div>
                    <div class="pay_item zz" :class="{active: selectIndex == 3}" @click='remit'>对公转账</div>
                    <div class="pay_item cf" v-show='!isPaper && $store.state.otherOrderId == "" && $store.state.Order.submitData && $store.state.Order.submitData.invoicetype == 0' :class="{active: selectIndex == 4}" @click='selectIndex = 4'>拆分支付</div>
                    <div class="pay_item yzf" v-if="!isPaper && $route.query.prepay" :class="{active: selectIndex == 5}" @click='selectIndex = 5'>预付款扣除</div> -->
                    <div style="margin-top:20px;">
                        <div class="tips" v-show='selectItem.payGateId == "9999" || payData && payData.invoiceType == 1'>
                            <p>直接汇款至{{companyDto && companyDto.companyJC}}银行账户 （如需发票，汇款账户名称即为发票名称）</p>
                            <br>
                            <template v-if="payData && payData.invoiceType == 1">
                                <p>开具增值税专用发票，需要通过公对公汇款方式，请用贵公司银行账户对下列我公司银行账户汇款，汇款成功后拨打电话4008113366联系我们，我们将为您办理授权（发货）。</p>
                                <br>
                            </template>
                            <p><!--<span v-if="!isPaper">(1)</span>-->银行账号信息</p>
                            <template v-if='!isPaper || (isPaper && paperBank == "8")'>
                                <p>公司名称：{{companyDto && companyDto.accountName}}</p>
                                <p>开户银行：{{companyDto && companyDto.bankName}}</p>
                                <p>汇款账号：{{companyDto && companyDto.bankAccount}}</p>
                                <br>
                                <p style="color: #a62424;"><img src="@/assets/image/tanhao1.png" style="vertical-align: top;" />请注意：需使用购买订单中填写的姓名/公司名称付款，否则无法确认付款身份，授权无法开通。</p>
                            </template>
                            <!-- <template v-if='!isPaper || (isPaper && paperBank == "3")'>
                                <p>公司名称：上海文华财经资讯股份有限公司</p>
                                <p>开户银行：农业银行上海期货大厦支行</p>
                                <p>汇款账号：0342&nbsp;7900&nbsp;0400&nbsp;0095&nbsp;2</p>
                                <br>
                            </template> -->
                            <!-- <template v-if='!isPaper'>
                                <p>(2)支付宝汇款</p>
                                <p>公司名称：上海文华财经资讯股份有限公司</p>
                                <p>支付宝账号：wh@wenhua.com.cn</p>
                            </template> -->
                        </div>
                    </div>
                    <NormalButton @click='pay' style="height:28px;width:80px;margin:50px auto 0;display:block;font-size:14px;"
                        theme='red'>{{payTxt}}
                    </NormalButton>
                    <div class="foot" v-common-display>
                        支付遇到问题，请致电<common-data name="serviceTel"/><common-data name="serviceTime"/>
                    </div>
                </div>
                <div class="result_box" v-show='resultShow'>
                    <table class="pay_table" border="0" cellspacing='0' cellpadding='0'>
                        <thead>
                            <tr>
                                <th colspan="2">订单信息</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="1">创建时间：<div class="content">{{resultData ? resultData.data.inputTime.split('T').join('    ') : ''}}</div>
                                </td>
                                <td colspan="1">订单号：<div class="content">{{resultData ? resultData.data.orderID : ''}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="1">购买人：<div class="content">{{resultData ? resultData.data.userName : ''}}</div>
                                </td>
                                <td colspan="1">手机号码：<div class="content">{{resultData ? resultData.data.phone : ''}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">是否需要发票：<div class="content">是（发票名头：{{resultData ? resultData.data.userName : ''}}）</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">发票类型：<div class="content">{{resultData && resultData.data.invoiceType == 0 ? '增值税普通发票（电子发票）':'增值税专用发票'}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    购买商品：<div class="content" v-html='memoTxt'></div><br><br>
                                    全额总计：<div class="content" v-html='resultData && resultData.total ? resultData.total:""'></div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">处理状态：<div class="content" v-html="dealstatus"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h4 class="tips_title" :class="{success:payStatus,error: !payStatus}">
                        {{tipsTitle}}
                        <a v-if='resultData && resultData.iscontract' :href="resultData ? resultData.pdfdata : ''" class='download_tmp'>点击下载纸质版合同</a>
                        <span style="font-size: 18px;display: inline-block;font-weight: normal;margin-left: 10px;" v-html="course_txt"></span>
                    </h4>
                    <p class="tips_txt" v-html='tipsTxt'></p>
                    <button class="red_btn" @click='close'>{{closeTxt}}</button>

                    <div style="display:none;" v-html="hiddenDom"></div>
                    
                </div>
            </div>
        <!-- </vue-scroll> -->
    </div>
</template>

<script>
    import service from '../assets/js/service'
    import wh from '../assets/js/wh'
    import cookie from 'js-cookie'
    import commonData from '../plugins/FetchCommonData/'

    let waitingFetch = wh.waitingFetch()
    let loopFetcher = null
    export default {
        name: "payment",
        props: {
            show: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                selectIndex: -1,
                selectItem: {},
                payShow: true,
                resultShow: false,
                payStatus: false,
                payData: null,
                resultData: null,
                hiddenDom: '',
                closeTxt: '',
                tipsTxt: '',
                tipsTitle: '',
                yunShortage: true,
                course_txt: ''
            }
        },
        computed: {
            dealstatus () {
                if (!this.resultData) return ''
                return (this.resultData && this.resultData.unpayMoney == 0) ? `<span class="green">处理完毕 ${this.resultData.data.inputTime.split('T').join('    ')}</span>`: `<span class="red">您还剩余${this.resultData.unpayMoney}元的订单金额待支付  ${this.resultData.data.inputTime.split('T').join('    ')}</span>`  
            },
            payTxt () {
                if (this.selectItem.payGateId == '9999') return '提交订单'
                else if (this.selectItem.payGateId == '9998') return '下一步'
                else return '去付款'
            },
            isTaiLi () {
                return this.$store.state.Order.submitData.productId == '127' || this.$store.state.Order.submitData.productId == '132'
            },
            //是否选则了纸质合同，只能用对公转账的方式
            isPaper () {
                return this.$store.state.Order.orderInfo ? this.$store.state.Order.orderInfo.iscontract : false
            },
            paperBank () {
                return this.$store.state.Order.orderInfo ? this.$store.state.Order.orderInfo.banks : ''
            },
            memoTxt () {
                if (this.resultData && this.resultData.data.memo != '') {
                    return this.resultData.data.memo
                } else if (this.resultData && this.resultData.data.memo == '') {
                    return this.resultData.data.product.productName
                } else {
                    return ''
                }
            },
            payTypes () {
                return this.$store.state.Order.orderInfo?.companyDto?.payConfigs.filter(v => this.$store.state.inIframe ? v.payName != '拆分支付' : true)
            },
            companyDto () {
                return this.$store.state.Order.orderInfo?.companyDto
            },
            isTProduct () {
                return this.$store.state.Order.submitData.productId == '1' || this.$store.state.Order.submitData.productId == '124' || this.$store.state.Order.submitData.productId == '138'
            },
            isWH5E () {
                return this.$store.state.Order.submitData.productId == '129'
            },
            isWT8 () {
                return this.$store.state.Order.submitData.productId == '122' || this.$store.state.Order.submitData.productId == '1'
            },
            isWT9 () {
                return this.$store.state.Order.submitData.productId == '124'
            },
        },
        inject: ['popOverShow','paymentShow','appOverFlow','seatInstance','clearAddBuyValidState', 'clearRenewBuyValidState'],
        methods: {
            async pay(finish) {
                let self = this
                let code = this.selectItem.payGateId
                if (this.selectIndex == -1) {
                    this.$market.alert({content: '请选择有效的支付方式。'})
                    finish()
                    return
                } else if (this.selectIndex == 5) {
                    code = '9991'
                }
                
                
                let waitPrePay = await new Promise((resolve)=>{
                    if (code == '9991') {
                        this.$market.accountValid({
                            ok (end,tip,account,pwd) {
                                this.$axios({
                                    url: '/api/Product/VipCustomerLogin',
                                    method: "post",
                                    data: {
                                        acc: account,
                                        pwd
                                    }
                                }).then(({data})=>{
                                    if (data.status) {
                                        end()
                                        resolve(data.data)
                                    } else {
                                        tip(data.message)
                                    }
                                    
                                })
                                       
                            },
                            close () {
                                resolve(false)
                            }
                        })
                            
                    } else {
                        resolve(true)
                    }
                    
                })
                if (!waitPrePay) return finish()


                if (!this.$store.state.Order.submitData) return this.$market.alert({content:'系统错误'})
                this.$axios({
                    url: '/api/Order/GetOrderID?payGateID=' + code + '&t=' + new Date().getTime(),
                    method: "get"
                }).then(res => {

                    let _orderid = ''
                    _orderid = res.data.orderid
                    this.$axios({
                        url: '/api/Product/GetProductIsHasStock?productId=' + this.payData.productId + '&t=' + new Date().getTime(),
                        method: "get"
                    }).then(res => {

                        if (!res.data.status && this.yunShortage) {
                            this.$market.alert({content: res.data.message})
                            this.yunShortage = false
                            finish()
                            return
                        }
                        let guid = cookie.get('seat_guid')
                        let data = {
                            "identityType": this.$store.state.Order.submitData.identityType || 0,
                            "morderid": this.$store.state.Order.submitData.morderid || '',
                            "userCode": this.$store.state.Order.submitData.userCode || '',
                            "subids": this.$store.state.Order.submitData.subids || '',
                            "isDanAuthorization": this.$store.state.Order.submitData.isDanAuthorization || false,
                            "userSdate": this.$store.state.Order.submitData.sdate || '',
                            "userEdate": this.$store.state.Order.submitData.time || '',
                            "userinformation": this.$store.state.Order.submitData.userinformation || '',
                            "orderID":_orderid,
                            "curyId": "",
                            "currency": "",
                            "productID": this.$store.state.Order.submitData.productId || this.$route.params.id,
                            "payGateID": code,
                            "userName": this.$store.state.Order.submitData.username || '',
                            "phone": this.$store.state.Order.submitData.phone || '',
                            "amount": this.$store.state.Order.submitData.amount || '',
                            "contactName": this.$store.state.Order.submitData.contactName || '',
                            "faxNumber": this.$store.state.Order.submitData.faxNumber || '',
                            "idCard": this.$store.state.Order.submitData.idCard || '',
                            "passport":this.$store.state.Order.submitData.passport || '',
                            "startdate": this.$store.state.Order.submitData.sdate || '',
                            "VipTicket": code == "9991" ? waitPrePay : '',
                            "IsDzh": this.$store.state.Order.submitData.identityType == '1' ? this.$store.getters['renewbuy/isDzh'] : false,
                            'xzh': this.$store.state.renewbuy.accounts.join(','),
                            'guid':guid,
                            'Seat': this.$store.state.seats,
                            'Wh10Account': this.$store.state.orderInfo.data.wh10Account || '',
                            'isTransAccount': this.$store.state.orderInfo.data.isWh10TryAccount || false,
                            'dzh': this.$store.state.orderInfo.data.dzh,
                            'ishotel': this.$store.state.Order.submitData.ishotel,
                            'inday': this.$store.state.Order.submitData.inday,
                            'outday': this.$store.state.Order.submitData.outday,
                            'isMonth': this.$store.state.orderInfo.data.isMonth,
                            'IsQuarter': this.$store.state.orderInfo.data.IsQuarter,
                            'CompanyId': this.$store.state.Order.submitData.identityType == 3 ? this.$store.state.addbuy.companyid : null ,
                            "isQuarter_sub": this.$store.state.Order.submitData.isQuarter_sub || false,
                            "sendProv": this.$store.state.Order.submitData.sendProv || ''
                        }
                        if (this.isWH5E) {
                            data.isTransAccount = this.$store.state.orderInfo.data.isWh5TransAccount
                            data.Wh10Account = this.$store.state.orderInfo.data.wh5Account
                        }
                        this.$axios({
                            url: '/api/Order/Payonline',
                            data,
                            method: "post"
                        }).then(res => {
                            finish()
                            if (!res.data.status) {
                                cookie.remove('seat_guid')
                                self.seatInstance() && self.seatInstance().clearSeat()
                                return self.$market.alert({
                                    content: res.data.message,
                                    confirmCall: ()=>{
                                        if (res.data.code == 202) {
                                            location.reload()
                                        }
                                    }
                                })
                            }
                            if (code == '9001') {
                                self.$market.QRCode({
                                    url: 'https://swarm.wenhua.com.cn/wxapi/QrCode/GetQRCode?plainText=' + res.data.data +
                                        '&pixel=6',
                                    text: '请打开支付宝，扫描下面的二维码进行支付：',
                                    confirmCall(loading,finish,falseBack) {
                                        loading()
                                        loopFetcher = waitingFetch('/api/Order/PayResult?orderid='+_orderid+'&subids='+self.$store.state.Order.submitData.subids+'&identityType=' + self.$store.state.Order.submitData.identityType,{
                                            method: 'get',
                                        })
                                        loopFetcher.then(res=>{
                                            self.payCallBack(res)
                                            finish()
                                        }).overtime(self.overtimeCallBack).catch(error => {
                                            self.$market.alert({
                                                content: '请求超时，请点击重试',confirmCall () {
                                                    falseBack()
                                                }
                                            })
                                        })
                                    },
                                    cancelCall() {

                                    }
                                })
                                
                            } else if (code == '9003') {
                            
                                self.$market.QRCode({
                                    url: 'https://swarm.wenhua.com.cn/wxapi/QrCode/GetQRCode?plainText=' + res.data.data +
                                        '&pixel=6',
                                    text: '请打开微信，扫描下面的二维码进行支付：',
                                    confirmCall(loading,finish,falseBack) {
                                        loading()
                                        loopFetcher = waitingFetch('/api/Order/PayResult?orderid='+_orderid+'&subids='+self.$store.state.Order.submitData.subids+'&identityType=' + self.$store.state.Order.submitData.identityType,{
                                            method: 'get'
                                        })
                                        loopFetcher.then(res=>{
                                            finish()
                                            self.payCallBack(res)
                                        }).overtime(self.overtimeCallBack).catch(error => {
                                            self.$market.alert({
                                                content: '请求超时，请点击重试',confirmCall () {
                                                    falseBack()
                                                }
                                            })
                                        })
                                    },
                                    cancelCall() {

                                    }
                                })
                            } else if (code == '9998') {
                                if (res.data.status) {
                                    self.$store.commit('setOtherId',res.data.orderid)
                                    self.$nextTick(_=>{
                                        self.$router.push({path:'/Detail/27'})
                                    })
                                    self.close()
                                    
                                }
                            } else if (code == '9000') {
                                finish()
                                localStorage.setItem('payDom',res.data.data)
                                
                                //防拦截
                                var newWin = window.open('about:blank')
                                newWin.location.href = '/#/ChinaPay/'
                                loopFetcher = waitingFetch('/api/Order/PayResult?orderid='+_orderid+'&subids='+self.$store.state.Order.submitData.subids+'&identityType=' + self.$store.state.Order.submitData.identityType,{
                                    method: 'get'
                                })
                                loopFetcher.then(res=>{
                                    self.payCallBack(res)
                                }).overtime(self.overtimeCallBack)
                            } else if (code == '9999') {
                                if (this.isWT8 && self.$store.state.Order.submitData.identityType != 3) {
                                    this.$market.wt8AlertWithBook({
                                        confirmCall (val) {
                                            if (val) {
                                                self.$market.book({
                                                    orderInfo: self.$store.state.Order.submitData,
                                                    orderId: _orderid ,
                                                    closePop: () => {
                                                        nextStep()
                                                    }
                                                })
                                            } else {
                                                nextStep()
                                            }
                                            function nextStep () {
                                                self.$axios({
                                                    url: '/api/Order/CheckOrder?orderid=' + _orderid + "&subids=" + (self.$store.state.Order.submitData.subids || '') +
                                                    '&identityType=' + (self.$store.state.Order.submitData.identityType || 0) + '&username=' + (self.$store.state.Order.submitData.username || ''),
                                                    method: 'get'
                                                }).then(res=>{
                                                    self.payCallBack(res)
                                                })
                                            }
                                        }
                                    })
                                } else {
                                    this.$market.alert({
                                        content: `<div style="width: 310px;"><div style="margin-bottom: 5px;">订单提交成功！</div>${[46,107].includes(self.$store.state.Order.submitData.productId)? '汇款成功后请与文华金融工程师热线4008113366联系，否则无法完成报名':'<span class="i_tips" style="margin-left: -26px;"></span>款项需在开通授权日前到账，否则订单自动取消；汇款后请拨4008113366通知我司确认款项，开通授权，谢谢合作！</div>'}`,
                                        confirmCall () {
                                            self.$axios({
                                                url: '/api/Order/CheckOrder?orderid=' + _orderid + "&subids=" + (self.$store.state.Order.submitData.subids || '') +
                                                '&identityType=' + (self.$store.state.Order.submitData.identityType || 0) + '&username=' + (self.$store.state.Order.submitData.username || ''),
                                                method: 'get'
                                            }).then(res=>{
                                                self.payCallBack(res)
                                            })
                                        }
                                    })
                                }
                            } else if (code == '9991') {
                                loopFetcher = waitingFetch('/api/Order/PayResult?orderid='+_orderid+'&subids='+self.$store.state.Order.submitData.subids+'&identityType=' + self.$store.state.Order.submitData.identityType,{
                                    method: 'get'
                                })
                                loopFetcher.then(res=>{
                                    self.payCallBack(res)
                                }).overtime(self.overtimeCallBack)
                                
                            }
                        }).catch(e=>{
                            finish()
                        })
                    })
                    
                }).catch(e =>{
                    finish()
                })
                
            },
            async payCallBack (res) {
                //支付成功回调
                //如果有选座界面的实例，把选座界面的已选座设置为已售
                let self = this
                if (res.data.data.payOk) {
                    cookie.remove('seat_guid')
                    this.$store.commit('setSeats','')
                    this.$store.commit('setIsbook', res.data.isbook)
                    this.$store.commit('setOrderID', res.data.data.orderID)
                }
                self.payShow = false
                self.resultShow = true
                self.resultData = res.data
                self.payStatus = res.data.data.payOk

                // console.log(res.data.isbook)
           

                let isPayOk = true
                if (res.data.data.payGateID == '9999') {//对公转账的支付情况，固定显示一个提示
                    self.payStatus = true
                    if ([46,107].includes(self.$store.state.Order.submitData.productId)) {
                        this.tipsTxt = ''
                    } else {
                        this.tipsTxt = '您购买的软件功能授权（或商品）将在款到后开通（发货）！'
                    }
                    
                    this.tipsTitle = '订单提交成功！'
                    this.closeTxt = '关闭'
                    return
                }
                if (!self.payStatus) {
                    this.tipsTxt = '如果确认已经支付成功，请不要重复支付，请通过订单号拨打4008113366与我们联系查询结果。'
                    this.tipsTitle = '订单支付失败'
                    this.closeTxt = '关闭'
                    isPayOk = false
                    return
                }
                if (res.data.unpayMoney == 0) {
                    let jifen_txt = ''
                    let wt8 = await commonData('appShortName_11')
                    if (res.data.isjf) {
                        jifen_txt += `<br>你现已是文华会员${this.resultData.data.phone} 本次购买获得会员积分${this.payData.price * 10}&nbsp;&nbsp;<a href="https://cloudid.wenhua.com.cn/Home/WenhuaID" target="_blank">查看会员权益</a>`
                    }
                    if (res.data.iscourse) {
                        this.course_txt += `线上课程视频入口：<a style="color: rgb(73, 132, 212);" href="https://wt8.wenhua.com.cn/#/aboveall" target="_blank">${wt8}官网</a>->购买->模型编写视频教程。`
                    }
                    this.$store.commit('setOtherId','')
                    if (this.isTaiLi) {
                        this.tipsTxt = '2个工作日内寄出台历；<br>7个工作日后，可使用预留的手机号登录本网“个人中心”下载电子发票。'
                        this.tipsTitle = '付款成功！'
                    }else if ([46,107].indexOf(res.data.data.productID) >= 0) {//培训班
                        this.tipsTxt = '如需发票，7个工作日后请使用预留的手机号登陆本网站个人中心下载电子发票。 '
                        this.tipsTitle = '付款成功！'
                    } else if (res.data.data.is_auto_account == 0) {//非正常购买
                        this.tipsTxt = `工作日3小时内会有工作人员电话与你联系，确认购买信息，请确保你预留的手机号畅通。<br>如需发票7个工作日后，请使用预留的手机号登录本网站用个人中心下载电子发票。${jifen_txt}`
                        this.tipsTitle = '支付成功！'
                    } else if (res.data.data.is_continue == 0) {//新购
                        if (!(/^[1][3,4,5,7,8][0-9]{9}$/.test(res.data.data.phone))) {
                            this.tipsTxt = `请拨打4008113366获得授权账号及密码！发票请在7个工作日后到个人中心下载。。`
                        } else {
                            this.tipsTxt = `授权账号及密码，5分钟内将以手机短信的形式发送给你，请注意查收！发票请在7个工作日后到个人中心下载。${jifen_txt}`
                        }
                        this.tipsTitle = '付款成功！'
                    } else if (res.data.data.is_continue == 2) {//加购
                        this.tipsTxt = `授权2个小时后生效。发票请在7个工作日后到个人中心下载。${jifen_txt}`
                        this.tipsTitle = '付款成功！'
                    } else if (res.data.data.is_continue == 1 || res.data.data.is_continue == 3) {//续费
                        let _oldxzh = res.data.data.oldxzh.indexof('wht') >= 0
                        if(_oldxzh.indexof('wht') >= 0 || _oldxzh.indexof('whn') >= 0 || _oldxzh.indexof('whq') >= 0 || _oldxzh.indexof('whe') >= 0) {
                                if (!(/^[1][3,4,5,7,8][0-9]{9}$/.test(res.data.data.phone))) {
                                    this.tipsTxt = `请拨打4008113366获得授权账号及密码！发票请在7个工作日后到个人中心下载。${jifen_txt}`
                                } else {
                                    this.tipsTxt = `发票请在7个工作日后到个人中心下载。${jifen_txt}`
                                }
                                this.tipsTitle = '续费成功！'
                        } else {
                            this.tipsTxt = '发票请在7个工作日后到个人中心下载。'
                            this.tipsTitle = '续费成功！'
                        }
                    }
                    this.closeTxt = '关闭'
                    
                } else {
                    this.tipsTxt = `需支付总计${res.data.data.price}元,其中已支付${res.data.data.price - res.data.unpayMoney}元,剩余应支付${res.data.unpayMoney}元，点击下方继续支付。如分笔付款未完成，下次继续付款请到装备超市-><a href="https://u.wenhua.com.cn/" style="color:blue;">个人中心</a>，登录完成支付剩余款项。`
                    this.tipsTitle = '付款成功！'
                    this.closeTxt = '继续支付'
                }
                
                this.$store.commit('setPayState', isPayOk)

              


            },
            overtimeCallBack() {
                //支付结果轮询超时回调
                this.$market.alert({content:'系统超时',confirmCall () {
                    this.close()
                }})
            },
            close () {
                //如果是星格官网通过iframe打开支付功能
                if (this.$store.state.inIframe) {
                    window.parent.postMessage('close', 'https://www.starquant.com.cn/');
                    return
                }
                this.popOverShow(false)
                this.paymentShow(false)
                this.appOverFlow('auto')
                this.clear()
                this.clearAddBuyValidState()()
                this.clearRenewBuyValidState()() 
            },
            clear () {
                loopFetcher && loopFetcher.clear()
                this.payShow = true
                this.selectIndex = -1
                this.selectItem = {}
                this.resultShow = false
                this.yunShortage = true
            },
            back () {
                this.$emit('back')
                this.clear()
            },
            selectPayType (item, index) {
                this.selectIndex = index
                this.selectItem = item
                if (item.payGateId == '9999') {
                    this.$nextTick(_=>{
                    this.$refs.scroll.scrollTop = 1000
                })
                }
            }
        },
        watch: {
            show (val) {
                if (val && this.$store.state.Order.orderInfo) {
                    this.clear()
                    this.payData = this.$store.state.Order.orderInfo
                    console.log(this.payData)
                }
            },
            isPaper: {
                handler (val) {
                    if(val == 1) {
                        this.selectIndex = this.payTypes.findIndex(v => v.payGateId == '9999')
                        this.selectItem = this.payTypes.find(v => v.payGateId == '9999')
                    }
                },
                immediate: true
            }
        },
        mounted() {
            
        }
    };
</script>

<style scoped>
    .scroll_container {
        padding-right:100px;
        height:100%;
        overflow:auto;
    }
    .download_tmp {
        margin-top: 15px;
        display: inline-block;
        color: rgb(0, 130, 218);
        font-size: 14px;
        font-weight: normal;
    }
    .back_btn {
        position: absolute;
        left: 20px;
        top: 14px;
        width: 30px;
        height: 30px;
    }
    .back_btn::before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 15px;
        height: 2px;
        background-color: #666;
        transform: rotate(-45deg);
    }
    .back_btn::after{
        content: '';
        position: absolute;
        top: 10px;
        left: 0;
        width: 15px;
        height: 2px;
        background-color: #666;
        transform: rotate(45deg);
    }
    .back_btn:hover::before,.back_btn:hover::after{
        background-color: #aaa;
    }
    .payment {
        position: fixed;
        width: 855px;
        right: 0;
        transform: translateX(100%);
        top: 0;
        bottom: 0;
        overflow: auto;
        z-index: 1001;
        background: url(../assets/image/bg_03.jpg) repeat;
        box-shadow: -3px 0 5px 0px #888;
        padding-left: 34px;
        box-sizing: border-box;
        transition: all 0.5s;
    }

    .payment.show {
        transform: translateX(0);
    }
    .close_btn {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 20px;
        top: 10px;
        z-index: 100;
    }

    .close_btn::before {
        content: '';
        width: 25px;
        height: 2px;
        background-color: rgb(53, 59, 63);
        position: absolute;
        top: 10px;
        left: 0;
        transform: rotate(45deg);
    }

    .close_btn::after {
        content: '';
        width: 25px;
        height: 2px;
        background-color: rgb(53, 59, 63);
        position: absolute;
        top: 10px;
        left: 0;
        transform: rotate(-45deg);
    }

    .close_btn:hover::before,
    .close_btn:hover::after {
        background-color: #999;
    }

    .content {
        display: inline-block;
        vertical-align: top;
        white-space: normal;
        word-break: break-all;
        width: calc(100% - 70px);
    }
    .content a{
        color: rgb(25, 141, 220);
    }
    .pay_table {
        width: 100%;
        margin-top: 60px;
        text-align: left;
        table-layout: fixed;
        border: 1px solid rgb(197, 197, 197);
        border-collapse: collapse;
    }

    .pay_table th {
        background: rgb(0, 130, 218);
        color: #fff;
        font-size: 14px;
        font-weight: normal;
        border: 1px solid rgb(197, 197, 197);
        padding: 12px 15px;
    }

    .pay_table td {
        padding: 12px 15px;
        border: 1px solid rgb(197, 197, 197);
        font-size: 14px;
        white-space: nowrap;
    }

    .title {
        color: rgb(96, 28, 29);
        padding-left: 10px;
        height: 16px;
        font-size: 14px;
        position: relative;
        margin-top: 40px;
    }

    .title::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 3px;
        background-color: rgb(96, 28, 29);
    }

    .pay_item {
        border: 1px solid rgb(219, 219, 219);
        background: white;
        width: 142px;
        height: 41px;
        margin-top: 20px;
        line-height: 41px;
        position: relative;
        display: inline-block;
        margin-right: 59px;
        cursor: default;
        padding-left: 60px;
        font-size: 14px;
        box-sizing: border-box;
    }

    .pay_item.active {
        border-color: rgb(0, 194, 2);
        box-shadow: 0 0 3px rgb(0, 194, 2);
    }

    .pay_item.active::before {
        content: '';
        width: 15px;
        height: 15px;
        border-top-left-radius: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        background: url(../assets/image/nsdd.png) no-repeat 5px 3px;
        background-color: rgb(0, 194, 2);
    }

    .pay_item.wx {
        background: url(../assets/image/wx_icon.png) 20px center no-repeat white;
        padding-left: 60px;
        box-sizing: border-box;
        font-size: 14px;
    }

    .pay_item.zfb {
        background: url(../assets/image/zfb_icon.png) 20px center no-repeat white;
        padding-left: 50px;
        box-sizing: border-box;
        font-size: 14px;
    }

    .pay_item.yl {
        background: url(../assets/image/yl_icon.png) 15px center no-repeat white;
        padding-left: 60px;
        box-sizing: border-box;
        font-size: 14px;
    }

    .pay_item.zz {
        background: url(../assets/image/zz_icon.png) 20px center no-repeat white;
        padding-left: 60px;
        box-sizing: border-box;
        font-size: 14px;
    }

    .pay_item.cf {
        background: url(../assets/image/cf_icon.png) 20px center no-repeat white;
        padding-left: 60px;
        box-sizing: border-box;
        font-size: 14px;
    }
    .pay_item.yzf {
        background:url(../assets/image/jigou_icon.png) 10px center no-repeat  white;
        padding-left: 45px;
        box-sizing: border-box;
        font-size: 14px;
    }
    .tips {
        font-size: 14px;
        color: rgb(111, 111, 111);
        border-top: 1px solid rgb(218, 218, 218);
        padding-top: 20px;
        position: relative;
    }

    .tips::before {
        content: '';
        border-bottom: 10px solid rgb(218, 218, 218);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        left: 60px;
        top: -10px;
    }

    .tips::after {
        content: '';
        border-bottom: 10px solid rgb(249, 249, 249);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        left: 60px;
        top: -9px;
        z-index: 1;
    }

    .tips p {
        padding: 0;
        margin: 0;
    }

    .foot {
        height: 65px;
        /* position: absolute;
        left: 34px;
        right: 100px;
        bottom: 0; */
        margin-top: 20px;
        border-top: 1px solid rgb(218, 218, 218);
        background: url(../assets/image/bg_03.jpg) repeat;
        line-height: 65px;
        color: rgb(150, 150, 150);
    }

    .result_box .tips_title.success {
        font-size: 20px;
        color: rgb(111, 111, 111);
        background: url(../assets/image/paysuccess.png) no-repeat left center;
        line-height: 30px;
        padding-left: 40px;
        margin-top: 100px;
    }

    .result_box .tips_title.error {
        font-size: 20px;
        color: rgb(111, 111, 111);
        background: url(../assets/image/payfailed.png) no-repeat left center;
        line-height: 30px;
        padding-left: 40px;
        margin-top: 100px;
    }
    .result_box .tips_txt {
        font-size: 16px;
        color: rgb(65, 65, 65);
        line-height: 28px;
    }
    .result_box .tips_txt >>> a {
        color: rgb(73, 132, 212);
    }
    .red_btn {
        width: 80px;
        height: 28px;
        background-color: rgb(230, 0, 0);
        color: white;
        font-size: 14px;
        border-radius: 3px;
        display: block;
        margin: 30px auto 0;
        border: 0;
        outline: 0;
    }
    /* @media screen and (max-width: 925px) {
        .payment {
            width: 100%;
            padding-left: 10px;
        }
        .scroll_container {
            padding-right: 10px;
        }
        .pay_item {
            margin-right: 30px;
            margin-left: 20px;
        }
        .pay_item:nth-child(2n) {
            margin-right: 0;
            margin-left: 0;
        }
        .foot {
            line-height: 20px;
        }
        .pay_table td {
            font-size: 12px;
            padding: 5px;
        }
    } */
</style>